// eslint-disable-next-line import/prefer-default-export
export const QuoteActionTypes = {
  SET_ENABLE_EARTHQUAKE_COVERAGE: 'SET_ENABLE_EARTHQUAKE_COVERAGE',
  SET_EARTHQUAKE_COVERAGE: 'SET_EARTHQUAKE_COVERAGE',
  SET_QUOTE: 'SET_QUOTE'
};
